import React from 'react'
import styled from 'styled-components'

import { User } from './User'
import { CurrentUser } from './CurrentUser'
import { useUserInfo } from '../../../store/user'
import { getOtherUsers } from './userPanelService'
import { isEditingUser, useEditingUsers } from '../../../store/socketServer'
import { useSocketServerState, getSocketId } from '../../../store/socketServer'

export const UsersPanel: React.FC = () => {
  const currentUser = useUserInfo()
  const editingUsers = useEditingUsers()
  const { roomState } = useSocketServerState()
  const users = getOtherUsers(roomState?.connectedUsers, currentUser.id, getSocketId())

  return (
    <Wrapper>
      {users.map((user, index) => (
        <User
          key={index}
          {...user}
          isFirst={!index}
          isLast={false}
          isEditing={isEditingUser(editingUsers, user.id)}
        />
      ))}
      <CurrentUser />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 4px;
`
